import { render, staticRenderFns } from "./DocumentViewerToolbar.vue?vue&type=template&id=0753fbe3&scoped=true&"
import script from "./DocumentViewerToolbar.vue?vue&type=script&lang=ts&"
export * from "./DocumentViewerToolbar.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentViewerToolbar.vue?vue&type=style&index=0&id=0753fbe3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0753fbe3",
  null
  
)

export default component.exports